<div class="form-modal modal-theme" style="min-width: 300px">
  <h2 mat-dialog-title>{{title | translate}}</h2>
  <div mat-dialog-content class="background-white padding-bottom-15">
    <div class="form-horizontal modal-dialog-custom">
      <div class="col-sm-12 min-width-50 no-padding ql-editor preview" [innerHtml]="message | translate | safeHtml">
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="closeDialog()">
        {{'CLOSE' | translate}}
      </button>
    </div>
  </div>
</div>